import ImageCard from '../ImageCard';
import { useTranslation } from 'react-i18next';
import { ILocation } from '../../types/resources/Location';
import React from 'react';
import styled from 'styled-components';
import LocationUtils from '../../utils/LocationUtils';
import LocationDateTime from './LocationDateTime';
import { useSettingsContext } from '../../context/settings/useSettingsContext';

const Content = styled.div`
  align-items: flex-start;
`

type TProps = {
    location: ILocation;
}

const LocationCard = ({location}: TProps) => {
    const {t} = useTranslation();
    const { locationFallbackImage } = useSettingsContext();

    const Container: React.FC<{ location: ILocation; children: React.ReactNode }> = ({location, children}) => {
        return location.imageUrl ? (
            <ImageCard
                imageSrc={
                    location.imageUrl
                    || locationFallbackImage
                }
                imageAlt={location.name ?? ''}
            >
                {children}
            </ImageCard>
        ) : (
            <div className="cr-image-card cr-flex cr-flex-col cr-bg-grey-light cr-shadow cr-rounded-block cr-h-100">
                {children}
            </div>
        );
    }

    // location.imageUrl = 'https://www.vdstappen.nl/wp-content/uploads/2021/11/uitvaart-van-een-kindje-min.jpg';

    return (
        <Container location={location}>
            <Content className="cr-location cr-p-lg cr-flex cr-flex-col cr-flex-1 cr-gap-sm cr-text-secondary">
                <div>
                    <div className={'cr-type'}>{location.typeDescription}</div>
                    <div className="cr-title cr-bold cr-text-alert cr-text-lg">
                        {location.name}
                    </div>
                </div>
                <LocationDateTime
                    startDateTime={location.startDateTime}
                    endDateTime={location.endDateTime}
                    dateTimeDisplay={location.dateTimeDisplay}
                    isPrivate={location.isPrivate}
                />
                {location.address &&
                    <div className={'cr-address'}>{location.address}</div>
                }
                {location.website &&
                    <a className={'cr-website'} href={location.website} target="_blank" rel="noreferrer">{location.website}</a>
                }
                {location.address &&
                    <div className={'cr-mt-auto cr-flex'}>
                        <a
                            className="cr-route cr-pill cr-bg-alert cr-text-white cr-my-xl"
                            href={LocationUtils.generateRouteUrl(location.address)} target="_blank" rel="noreferrer"
                        >
                            {t('plan-route')}
                        </a>
                    </div>
                }
            </Content>
        </Container>
    );
}

export default LocationCard;
